import { render, staticRenderFns } from "./AddSalesDeliveryComponent.vue?vue&type=template&id=2f452084&"
import script from "./AddSalesDeliveryComponent.vue?vue&type=script&lang=js&"
export * from "./AddSalesDeliveryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports